var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlwaysAvailableIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1621,
    height: 1621,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 942,
    y: 70,
    width: 1621,
    height: 1621
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-942 -70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2322.7 409.866 2320.93 410.758 2322.69 411.048ZM1752.5 70.0001C1972.82 70.0001 2172.6 157.906 2318.69 300.556L2323.53 305.809 2324.49 185.427 2397.47 272.135 2397.47 280.969 2396.66 278.76 2396.66 500.701 2211.17 470.09 2175.63 464.082 2100.07 374.309 2234.99 396.576 2234.13 395.63C2110.91 272.404 1940.67 196.186 1752.63 196.186 1376.56 196.186 1071.69 501.055 1071.69 877.13 1071.69 1253.21 1376.56 1558.07 1752.63 1558.07 2128.71 1558.07 2433.58 1253.21 2433.58 877.13 2433.58 841.873 2430.9 807.242 2425.73 773.43L2424.28 765.828 2548.39 729.552 2553.66 757.069C2559.81 797.315 2563 838.535 2563 880.5 2563 1328.13 2200.13 1691 1752.5 1691 1304.87 1691 942 1328.13 942 880.5 942 432.873 1304.87 70.0001 1752.5 70.0001Z",
    fill: "#F9F9F9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#F9F9F9",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 367,
    transform: "matrix(1 0 0 1 1374.98 874)"
  }, "24"), /*#__PURE__*/React.createElement("text", {
    fill: "#F9F9F9",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 367,
    transform: "matrix(1 0 0 1 1926.53 1154)"
  }, "7"), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 483.498 500.462",
    stroke: "#F9F9F9",
    strokeWidth: 12.6042,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 1602.5 1127.96)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlwaysAvailableIconWhite);
export default __webpack_public_path__ + "static/media/AlwaysAvailableIcon_white.eb87f2dec8ebcc1a662c27375af48b08.svg";
export { ForwardRef as ReactComponent };